<template>
	<div>
		<router-link :to="{ name: 'orders' }">
			<span class="fa fa-long-arrow-alt-left" />
			Return to orders
		</router-link>

		<h1 class="mt-2 mb-2">Order #{{ order.id }}</h1>

		<div class="row mt-2 mb-2">
			<div class="col-12 col-md-6">
				<h6 class="text-muted mb-4">
					Fullname: {{ order.fullname }}
				</h6>
				<h6 class="text-muted mb-4">
					Phone: {{ order.phone }}
				</h6>
				<h6 class="text-muted mb-4">
					Email: {{ order.email }}
				</h6>
				<h6 class="text-muted mb-4">
					Residency: {{ order.residency }}
				</h6>
				<h6 class="text-muted mb-4">
					Address: {{ order.address }}
				</h6>
			</div>
			<div class="col-12 col-md-6">
				<h6 class="text-muted mb-4">
					Payment Type: {{order.payment_type}}
					<!-- <span v-if="order.payment_type == null">N/A</span>
					<span v-if="order.payment_type == '0'">Cash</span>
					<span v-if="order.payment_type == '1'">Sadad</span>
					<span v-if="order.payment_type == '2'">MasterCard</span>
					<span v-if="order.payment_type == '3'">Visa</span>
					<span v-if="order.payment_type == '4'">Mada</span> -->

					<template
						v-if="order.payment_type == null || order.payment_type == '0' || order.payment_type == '1'">
						({{ order.paid ? 'Paid' : 'Unpaid' }})
					</template>
				</h6>
				<h6 class="text-muted mb-4"> 
					Operation Code: {{order.trans_code}}
				</h6>
				<h6 class="text-muted mb-4">
					Total: {{ order.total }} $
				</h6>
				<h6 class="text-muted mb-4">
					Total after discount: {{ order.total_after_vat }} $
				</h6>
				<h6 class="text-muted mb-4">
					Total with shipping cost: {{ order.total_after_shipping }} $
				</h6>
				<h6 class="text-muted mb-4">
					Date: {{ order.created_at }}
				</h6>
			</div>
		</div>

		<h3 class="mt-2 mb-2">Order Details</h3>
		<datatable class="mt-2" style="height: 70vh;" :cols="columns" :rows="order.cart.products" />
	</div>
</template>

<script>
import store from '../../../store';
import { mapGetters } from 'vuex';
import DataTable from '../../DataTable';

export default {
	components: {
		'datatable': DataTable,
	},

	data: () => ({
		columns: [
			{ headerName: 'ID', field: 'product.id', sortable: true, filter: true, resizable: true, minWidth: 50, maxWidth: 75 },
			{ headerName: 'Name', field: 'product.name', sortable: true, filter: true, resizable: true, minWidth: 200, },
			{ headerName: 'Type', field: 'product.catalog_name', sortable: true, filter: true, resizable: true, minWidth: 150, },
			{ headerName: 'Price', field: 'product.price', sortable: true, filter: true, resizable: true, minWidth: 75, 
				cellRenderer: params => params.value ? Number(params.value).toFixed(2) + ' $ ' : params.value
			},
			{ headerName: 'Quantity', field: 'quantity', sortable: true, filter: true, resizable: true, minWidth: 75, },
			{ headerName: 'Total', field: 'total', sortable: true, filter: true, resizable: true, minWidth: 75, 
				cellRenderer: params => params.value ? Number(params.value).toFixed(2) + ' $ ' : params.value
			},
		],
	}),

	computed: {
		...mapGetters({
			getOrderById: 'orders/getById',
		}),

		order() {
			return this.getOrderById(parseInt(this.$route.params.id));
		},
	},

	async beforeRouteEnter(to, from, next) {
		await store.dispatch('orders/fetch', { id: parseInt(to.params.id) });
		next();
	},

	meta: {
		title: 'View an order',

		meta: [
			{ property: 'og:title', content: 'View an order / Al-Shayah' },
		],
	},
}
</script>